import * as React from "react";

import { cn } from "../lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-20 w-full rounded-crane-md border border-crane-input bg-crane-background px-3 py-2 text-sm shadow-crane-soft placeholder:text-crane-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crane-ring focus-visible:ring-offset-2 focus-visible:ring-offset-crane-background disabled:cursor-not-allowed disabled:opacity-50",
          // Stan błędu niesie ramka pola, nie etykieta — patrz komentarz przy `FormLabel`.
          "aria-[invalid=true]:border-crane-destructive",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
